
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPreset/addPage/pagePreview/multiplePresetIndication.scss.css.virtualfile';
        module.exports = {"multiplePresetIndication":"_multiplePresetIndication_7a2b9_7"};